import { atom } from "recoil";

import {
  defaultBookingsPollingState,
  IBookingsPollingCombinedState,
} from "../../models";

export const bookingsPollingStateAtom = atom<
  IBookingsPollingCombinedState | undefined
>({
  key: "bookingsPollingStateAtom",
  default: defaultBookingsPollingState,
});

export const bookingsPollingRunningCountAtom = atom<number>({
  key: "bookingsPollingRunningCountAtom",
  default: 0,
});
